import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { useContext, useEffect, useState } from "react";

import {
  Accordion,
  AccordionHeader,
  AccordionHeaderName,
  HyphenIcon,
  Loader,
} from "@transfr-inc/dashboard-components";
import { Button } from "@transfr-inc/dashboard-components/forms";

import { AppContext } from "@context/app.context";
import { ApplicationId } from "@lib/constants";
import { ConfigurationKeys } from "@services/configuration";
import { services } from "@src/dependencies";
import { useApiRequest } from "@utils/http-client";

import { VrSettingsModal } from "../modals";
import { useConfigurations } from "../modals/vr-settings/api";

import "./disciplines.section.scss";

export const CareersSection = ({ className, organization }) => {
  const { isVRCustomizationEnabled } = useContext(AppContext);
  const [open, setOpen] = useState(false);
  const [showVRSettings, setShowVRSettings] = useState(false);

  const { organizationService } = services;
  const { response: data, loading } = useApiRequest(() =>
    organizationService.getOrganizationSimulations(organization?.code),
  );

  const { getConfigurations } = useConfigurations(
    ApplicationId.TREK_VR,
    organization.id,
    {
      onSuccess: (data) => {
        setShowVRSettings(
          Object.values(ConfigurationKeys).some((key) => data[key]),
        );
      },
    },
  );

  useEffect(() => {
    if (isVRCustomizationEnabled) {
      getConfigurations();
    }
  }, []);

  return (
    <div
      className={clsx("disciplines-section", loading && "loader", className)}
    >
      <div className="disciplines-section-header">
        <h2>
          Simulations{" "}
          <span className="badge">
            {data?.simulations.length ?? <HyphenIcon />}
          </span>
        </h2>
        {showVRSettings && (
          <>
            <Button className="icon" onClick={() => setOpen(true)}>
              <FontAwesomeIcon icon="far fa-gear" />
            </Button>
            <VrSettingsModal
              open={open}
              organization={organization}
              onClose={() => setOpen(false)}
            />
          </>
        )}
      </div>

      <div className="content-section">
        {data?.simulations.map((d) => (
          <Accordion key={`career-${d.id}`}>
            <AccordionHeader>
              <AccordionHeaderName>{d.name}</AccordionHeaderName>
            </AccordionHeader>
          </Accordion>
        ))}
        {loading && <Loader overlay fixed />}
      </div>
    </div>
  );
};
